export class BusinessError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "BusinessError";
  }
}

type ApiResponse<T> = {
  error?: string;
  data?: T;
};

export function handleApiResponse<T>(response: ApiResponse<T>): T {
  if ("error" in response && response.error) {
    throw new BusinessError(response.error);
  }

  return response as T;
}
